<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
*{  
      margin: 0px;  
      padding: 0px;  
  } 
#app {
  font-family: 'Microsoft YaHei','Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
body{
  margin: 0;
  background-color: #f5f7f9;
}
em{	
  font-style: normal;
}
.ivu-poptip-inner .ivu-poptip-body{
  color: #2196f3;
}
.ivu-poptip-inner i{
  left:20px;
}
/*工具栏*/
.tools{
  padding: 10px;
  border-bottom: solid 1px #ededed;
  position: relative;
}
.tools .title{
  line-height: 36px;
}
.right{
  position: absolute;
  top:12px;
  right: 10px;
}
.rightTxt{
  position: absolute;
  top:12px;
  right: 10px;
  line-height: 32px;
  font-size: 14px;
  font-weight: 600;
  color: #00b9ff;
  text-shadow:1px 1px 4px #ccc;
}
.noData{
  padding: 40px;
  text-align: center;
  font-size: 14px;
  color: #999;
}
/*隐藏1行*/
.hide1{
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
/*隐藏2行*/
.hide2{
 /* width: 100%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;*/
  display: -webkit-box;
  -webkit-line-clamp:2;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
}
/* 颜色 */
.text-red{
  color: #e70012;
}
.text-green{
  color: #079a3f;
}
.text-yellow{
  color: #f90;
}
.text-purple{
  color: #7b308d;
}
/* 红：#e70012   绿：#079a3f     黄：#ffcd00    紫：#7b308d */

.text-center{
  text-align: center;
}

.modulesAct .ivu-badge-dot {
  top: 14px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue